if (!customElements.get('scrolling-image-with-text')) {
  customElements.define(
    'scrolling-image-with-text',
    class ScrollingImageWithText extends HTMLElement {
      constructor() {
        super();
        this.sliderInstance = null;
        this.isDesktop = window.innerWidth >= 1000;
      }

      connectedCallback() {
        if (!window.FoxTheme || !window.FoxTheme.Carousel) return;

        this.swiperEl = this.querySelector('.swiper');
        this.contentItems = [...this.querySelectorAll('.scrolling-content-item')];
        this.paginationEl = this.querySelector('.swiper-pagination');
        this.progressBar = this.querySelector('scrolling-progress-bar .progress-active');

        if (!this.swiperEl || !this.contentItems.length) return;

        this.totalSlides = this.swiperEl.querySelectorAll('.swiper-slide').length;

        this.initSlider();
        this.bindContentNavigation();
        this.bindResize();
      }

      getDirection() {
        return window.innerWidth >= 1000 ? 'vertical' : 'horizontal';
      }

      initSlider() {
        this.sliderInstance = new window.FoxTheme.Carousel(this.swiperEl, {
          direction: this.getDirection(),
          slidesPerView: 1,
          speed: 600,
          allowTouchMove: true,
          watchSlidesProgress: true,
          pagination: this.paginationEl
            ? { el: this.paginationEl, clickable: true }
            : false,
        });

        this.sliderInstance.init();

        const swiper = this.sliderInstance.slider;

        swiper.on('slideChange', () => {
          const index = swiper.activeIndex;
          this.setActiveContent(index);
          this.updateProgress(index);
          this.scrollActiveContentIntoView(index);
        });

        this.setActiveContent(swiper.activeIndex || 0);
        this.updateProgress(swiper.activeIndex || 0);
      }

      bindResize() {
        window.addEventListener('resize', () => {
          const isDesktopNow = window.innerWidth >= 1000;
          if (isDesktopNow !== this.isDesktop) {
            this.isDesktop = isDesktopNow;
            this.reInitSlider();
          }
        });
      }

      reInitSlider() {
        if (this.sliderInstance) {
          this.sliderInstance.slider.destroy(true, true);
          this.sliderInstance = null;
        }
        this.initSlider();
      }

      bindContentNavigation() {
        this.contentItems.forEach((item, index) => {
          item.addEventListener('click', () => {
            this.sliderInstance.slider.slideTo(index);
          });
        });
      }

      setActiveContent(activeIndex) {
        this.contentItems.forEach((item, index) => {
          item.classList.toggle('is-active', index === activeIndex);
        });
      }
        scrollActiveContentIntoView(activeIndex) {
            if (window.innerWidth >= 1000) return;

            const activeItem = this.contentItems[activeIndex];
            if (!activeItem) return;

            activeItem.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
            });
        }
      updateProgress(activeIndex) {
        if (!this.progressBar || this.totalSlides <= 1) return;

        const container = this.progressBar.parentElement;

        if (window.innerWidth >= 1000) {
          // ✅ Vertical progress
          const containerHeight = container.clientHeight;
          const step = containerHeight / this.totalSlides;

          this.progressBar.style.height = `${step}px`;
          this.progressBar.style.width = `100%`;
          this.progressBar.style.transform = `translateY(${step * activeIndex}px)`;
        } else {
          // ✅ Horizontal progress
          const containerWidth = container.clientWidth;
          const step = containerWidth / this.totalSlides;

          this.progressBar.style.width = `${step}px`;
          this.progressBar.style.height = `100%`;
          this.progressBar.style.transform = `translateX(${step * activeIndex}px)`;
        }
      }

      disconnectedCallback() {
        if (this.sliderInstance) {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = null;
        }
      }
    }
  );
}
